var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000000",
    strokeWidth: 1.3,
    transform: "translate(9 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 11,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M1 0l7.656 6.711a.5.5 0 0 0 .66 0L16.972 0"
  }))));
};
export default SvgMail;